module.exports = __webpack_public_path__ + "static/media/carousel1.c34b7960.jpg";